import { render } from "./Pagetree.vue?vue&type=template&id=3d214738&scoped=true&ts=true"
import script from "./Pagetree.vue?vue&type=script&lang=ts"
export * from "./Pagetree.vue?vue&type=script&lang=ts"

import "./Pagetree.vue?vue&type=style&index=0&id=3d214738&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d214738"]])

export default __exports__